export const SERVICE_PACKAGE_TYPES = [
  'HORUS_ADVANCED_SEARCH',
  'GENERIC_IA_DISCOUNT',
  'STORAGE_DISCOUNT',
] as const;

export type ServicePackageType = (typeof SERVICE_PACKAGE_TYPES)[number];

export const DISCOUNT_PACKAGE_TYPES = [
  'GENERIC_IA_DISCOUNT',
  'STORAGE_DISCOUNT',
] as const satisfies readonly ServicePackageType[];

export type DiscountPackageType = (typeof DISCOUNT_PACKAGE_TYPES)[number];

export function isDiscountPackageType(
  type: string | null | undefined,
): type is DiscountPackageType {
  return (DISCOUNT_PACKAGE_TYPES as readonly string[]).includes(type ?? '');
}

export const SERVICE_PACKAGE_TYPE_LABELS: Record<ServicePackageType, string> = {
  HORUS_ADVANCED_SEARCH: 'service_packages.types.HORUS_ADVANCED_SEARCH',
  GENERIC_IA_DISCOUNT: 'service_packages.types.GENERIC_IA_DISCOUNT',
  STORAGE_DISCOUNT: 'service_packages.types.STORAGE_DISCOUNT',
};

export type ServicePackageStatus = 'ATIVO' | 'INATIVO' | 'ENCERRADO';

export function servicePackageStatus(
  item: Pick<ServicePackage, 'start' | 'finish'>,
  now: Date = new Date(),
): ServicePackageStatus {
  if (item.finish && new Date(item.finish) < now) return 'ENCERRADO';
  if (new Date(item.start) > now) return 'INATIVO';
  return 'ATIVO';
}

export interface ServicePackage {
  id: number;
  whitelabelId: number;
  type: ServicePackageType;
  value: number;
  amount: number;
  start: string;
  finish: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateServicePackageDto {
  type: ServicePackageType;
  value: number;
  amount: number;
  start: string;
  finish: string | null;
  justification: string;
}

export type UpdateServicePackageDto = CreateServicePackageDto;

export interface ServicePackagesResponse {
  items: ServicePackage[];
  total: number;
  currentPage: number;
  perPage: number;
  lastPage: number;
}

export interface ServicePackageLogChange {
  from: unknown;
  to: unknown;
}

export interface ServicePackageLogUser {
  id: number;
  name: string;
  email: string;
}

export interface ServicePackageLog {
  id: number;
  packageId: number;
  action: string;
  changedBy: number;
  justification: string | null;
  changes: Record<string, ServicePackageLogChange> | null;
  createdAt: string;
  user: ServicePackageLogUser;
}

export interface ServicePackagesReportPayload {
  startDate: string;
  endDate?: string;
  whitelabelId?: number;
  types: ServicePackageType[];
}

export interface ServicePackagesReportJobResponse {
  message: string;
  fileProcessingId: number;
}
